import useCollection from "web/hooks/data/useCollection"

export default function useImports({ type, subject, swrOptions = {} }) {
  const key = type ? [type, subject?.resource_type, subject?.id] : null
  return useCollection({
    key: key,
    url: "/imports",
    params: {
      type: type,
      subject_type: subject?.resource_type,
      subject_id: subject?.id,
    },
    swrOptions: swrOptions,
  })
}
